module.exports = __webpack_public_path__ + "img/more2.dbcd094b.svg";